import "@/styles/dynamic_page.scss"

import { setupAccordions } from "@/components/content/Accordion"
import { loadBackgroundImages } from "@/helpers/image_loader"

loadBackgroundImages()
setupAccordions()
